import { CouponModel, OfferType } from '../utils/Models';
import { DataGrid, GridColumns, GridSortItem } from "@mui/x-data-grid";
import { Colors } from '../../config/Constants';
import { DateTime } from 'luxon';
import { Box, Switch } from '@mui/material';

// OfferType to format map
const offerTypeToFormat: { [k in OfferType]: { pre: string, post: string } } = {
  FLAT: { pre: 'Flat ₹', post: ' Off' },
  PERCENT: { pre: '', post: '% Off' },
  GBK_COMMISSION_PERCENT: { pre: '', post: '% Off from GoWheelo Commission' },
  FREE_KMS: { pre: 'Free ', post: ' Km' },
  FREE_ACCSSORY: { pre: 'Free accessory ID - ', post: '' },
  GO_COINS: { pre: 'Free ', post: '% Go Coins' },
}

// Booking grid component
export function OfferTable(props: {
  offerList: CouponModel[],
  setParentState: any,
  containerClass: any,
  setOfferActive: (offerId: number, newState: boolean) => any
}) {
  const dgProps = {
    disableColumnMenu: true,
    disableColumnFilter: true,
    className: 'gbk-dg',
    rowHeight: 50,
    pageSize: 10,
    sortModel: [{ field: 'id', sort: 'desc' }] as GridSortItem[],
    columns: [{
      field: 'code',
      headerName: 'Code',
      width: 150,
      align: 'center',
      renderCell: o => <b style={{ color: Colors.primary }}>{o.value}</b>,
      sortable: false
    }, {
      field: 'offerStart',
      headerName: 'Start Date',
      width: 200,
      align: 'center',
      renderCell: o => DateTime.fromMillis(Number(o.value)).toLocaleString(DateTime.DATETIME_MED),
      sortable: false
    }, {
      field: 'offerEnd',
      headerName: 'End Date',
      width: 200,
      align: 'center',
      renderCell: o => DateTime.fromMillis(Number(o.value)).toLocaleString(DateTime.DATETIME_MED),
      sortable: false
    }, {
      field: 'value',
      headerName: 'Offer',
      width: 400,
      align: 'center',
      renderCell: (o: { row: CouponModel, value: string }) => {
        const value = o.row.offerType === OfferType.PERCENT || o.row.offerType === OfferType.GO_COINS ? Number(o.value) * 100 : o.value;
        return `${offerTypeToFormat[o.row.offerType].pre}${value}${offerTypeToFormat[o.row.offerType].post}`;
      },
      sortable: false
    }, {
      field: 'active',
      headerName: 'Active',
      width: 110,
      align: 'center',
      renderCell: (o: { row: CouponModel }) => (
        <Switch checked={o.row.active} onChange={(_, newState) => { props.setOfferActive(o.row.id as number, newState) }} />
      ),
      sortable: false
    }] as GridColumns
  }

  return <div className={props.containerClass}>
    {/* PC Grid */}
    <DataGrid
      sx={{ display: { xs: 'none', md: 'flex' } }}
      disableColumnMenu={dgProps.disableColumnMenu}
      disableColumnFilter={dgProps.disableColumnFilter}
      className={dgProps.className}
      rowHeight={dgProps.rowHeight}
      rows={props.offerList || []}
      columns={dgProps.columns}
      pageSize={dgProps.pageSize}
      rowsPerPageOptions={[dgProps.pageSize]}
      sortModel={dgProps.sortModel}
      disableSelectionOnClick
    />
    {/* Phone Grid */}
    <DataGrid
      sx={{ display: { xs: 'flex', md: 'none' } }}
      disableColumnMenu={dgProps.disableColumnMenu}
      disableColumnFilter={dgProps.disableColumnFilter}
      className={`${dgProps.className} phone`}
      rowHeight={163}
      rows={props.offerList || []}
      columns={dgProps.columns}
      pageSize={dgProps.pageSize}
      rowsPerPageOptions={[dgProps.pageSize]}
      disableSelectionOnClick
      headerHeight={0}
      sortModel={dgProps.sortModel}
      components={{
        Row: (data: { row: CouponModel }) => (
          <Box className='gbk-dg-row-phone'>
            <Box className='gbk-dg-row-phone-header' key={1} >
              {data.row.code}
            </Box>
            <Box
              className='gbk-dg-row-phone-body'
              key={2}
            >
              <div style={{ display: 'inline-block', verticalAlign: 'top' }}>
                Start: <b style={{ fontSize: '14px' }}>{DateTime.fromMillis(Number(data.row.offerStart)).toLocaleString(DateTime.DATETIME_MED)}</b> <br />
                End: <b style={{ fontSize: '14px' }}>{DateTime.fromMillis(Number(data.row.offerEnd)).toLocaleString(DateTime.DATETIME_MED)}</b> <br />
                Description: {data.row.description}<br />
                <b style={{ fontSize: '14px', color: Colors.primary }}>
                  {`${offerTypeToFormat[data.row.offerType].pre}${data.row.offerType === OfferType.PERCENT || data.row.offerType === OfferType.GO_COINS ? Number(data.row.value) * 100 : data.row.value}${offerTypeToFormat[data.row.offerType].post}`}
                </b>
              </div>
              <div style={{ float: 'right' }}>
                <Switch checked={data.row.active} onChange={(_, newState) => { props.setOfferActive(data.row.id as number, newState) }} />
              </div>
            </Box>
          </Box>
        )
      }}
    />
  </div >
}